import { Checkbox } from "@fronterahealth/frontera-ui-components/ui/checkbox";
import { Field, FieldLabel } from "@fronterahealth/frontera-ui-components/ui/field";

import { parseJson } from "@components/FieldComponent/utils";
import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { ReportFieldInputBaseProps } from "@components/ReportField/types";

const parseCheckboxValue = (value: string | null | undefined): string[] => {
  const parsed = parseJson<unknown>(value);
  return Array.isArray(parsed) ? parsed : [];
};

export const TreatmentPlanCheckbox: React.FC<ReportFieldInputBaseProps> = ({
  id,
  value,
  onChange,
  selectOptions = [],
  disabled,
  onFocus,
  onBlur,
}) => {
  const checked = parseCheckboxValue(value);
  if (disabled) {
    const labels = selectOptions.filter((opt) => checked.includes(opt.id || opt.primary)).map((opt) => opt.primary);
    return <ReportFieldDisabledValue value={labels.join(", ")} />;
  }
  const toggle = (optionValue: string, isChecked: boolean) => {
    const next = isChecked ? [...checked, optionValue] : checked.filter((v) => v !== optionValue);
    onChange(JSON.stringify(next));
  };
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-input px-4 py-2">
      {selectOptions.map((opt) => {
        const optionValue = opt.id || opt.primary;
        return (
          <Field key={optionValue} orientation="horizontal">
            <Checkbox
              id={`${id}-${optionValue}`}
              checked={checked.includes(optionValue)}
              onCheckedChange={(isChecked) => toggle(optionValue, isChecked)}
              onFocus={onFocus}
              onBlur={onBlur}
            />
            <FieldLabel htmlFor={`${id}-${optionValue}`}>{opt.primary}</FieldLabel>
          </Field>
        );
      })}
    </div>
  );
};
